module.exports = __webpack_public_path__ + "img/happytablet_info3.13a5f5ae.jpg";